import constants from "./CONSTANTS";

const actions = {
  getPrivacyPolicies: ()=> ({
    type: constants.GET_PRIVACY_POLICIES,
  }),

  setPrivacyPolicies: (payload)=> ({
    type: constants.SET_PRIVACY_POLICIES,
    payload
  })
};

export default actions;
